export default __webpack_public_path__ + "static/media/Accessibility_Dark.930a1573.svg";